import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-ivory py-16 sm:py-24" data-id="element-125" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-3xl px-5" data-id="element-126" data-mp="1o3dj01a9xtlv">
        <div className="border border-gold-soft bg-white px-7 py-12 text-center shadow-card sm:px-12" data-id="element-127" data-mp="223y4j57kq3j2">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold-tint" data-id="element-128" data-mp="1x42054uysa2z">
            <ShieldCheckIcon className="h-7 w-7 text-gold-dark" aria-hidden="true" data-id="element-129" data-mp="19fsk6jkfmgjr" />
          </span>

          <h2 className="mt-7 font-serif text-3xl sm:text-4xl text-ink" data-id="element-130" data-mp="14gpeqy0ji8b9">
            7-day guarantee — no questions asked
          </h2>
          <div className="rule-gold mx-auto mt-7 w-24" aria-hidden="true" data-id="element-131" data-mp="1j6n6tp1lbi5q" />

          <p className="mt-7 font-serif text-xl italic text-gold-dark" data-id="element-132" data-mp="1ed28fvw34m60">
            Download it. Open every volume. Use it with a real client.
          </p>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-ink-soft" data-id="element-133" data-mp="lpg0kbftqvdc">
            If within 7 days it&rsquo;s not what you expected, we refund 100% — no forms,
            no hoops, no hard feelings.
          </p>
        </div>
      </div>
    </section>;
}